import { render, staticRenderFns } from "./DashboardFilter.vue?vue&type=template&id=243d0bba&"
import script from "./DashboardFilter.vue?vue&type=script&lang=js&"
export * from "./DashboardFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports